import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdobeLaunchService } from '../shared/services/adobe-launch.service';
import { HeroCardConfig } from './partials/hero-card/hero-card-config.interface';

@Component({
  selector: 'home-v2',
  templateUrl: './home-v2.component.html',
  styleUrls: ['./home-v2.component.scss'],
})
export class HomeV2Component implements OnInit {
  accordionItems = [0, 1, 2, 3];

  myciCardConfig: HeroCardConfig = {
    imageSrc: 'assets/images/myci-student-dashboard-homepage.png',
    imageAltKey: 'homeV2.myciHero.imageAlt',
    headingKey: 'homeV2.myciHero.heading',
    chipLabelKey: 'homeV2.myciHero.chipLabel',
    chipColor: 'yellow',
    bodyKey: 'homeV2.myciHero.body',
    checkItemKeys: [
      'homeV2.myciHero.checkList.item1',
      'homeV2.myciHero.checkList.item2',
      'homeV2.myciHero.checkList.item3',
    ],
    buttonLabelKey: 'homeV2.myciHero.buttonLabel',
    buttonHref: 'homeV2.myciHero.buttonHref',
    linkTextKey: 'homeV2.myciHero.linkText',
    linkRoute: '/invest',
  };

  myceCardConfig: HeroCardConfig;

  constructor(
    private readonly adobeLaunchService: AdobeLaunchService,
    private readonly translateService: TranslateService,
  ) {
    const lang = this.translateService.getCurrentLang() || 'en';
    this.myceCardConfig = {
      imageSrc: 'assets/images/myce-student-dashboard-homepage.png',
      imageAltKey: 'homeV2.myceCard.imageAlt',
      headingKey: 'homeV2.myceCard.title',
      bodyKey: 'homeV2.myceCard.description',
      checkItemKeys: [
        'homeV2.myceCard.bullet_0',
        'homeV2.myceCard.bullet_1',
        'homeV2.myceCard.bullet_2',
      ],
      buttonLabelKey: 'homeV2.myceCard.ctaButton',
      buttonHref: `https://digital.myclassroomeconomy.org/${lang}/register`,
      linkTextKey: 'homeV2.myceCard.link',
      linkRoute: '/digital',
    };
  }

  ngOnInit(): void {

    document.documentElement.classList.add('default-font-size');
    this.adobeLaunchService.trackPageView({
      pageTitle: 'Home',
    });
  }
}
